import { SeoEffects } from './seo.effects';

export const effects: any[] = [SeoEffects];
